import { createContext } from 'react';

import { Data } from './lib/datatype';

// eslint-disable-next-line
export const DataContext = createContext<Data>(null as any);
